import { FormControl, MenuItem, Select, Box } from '@mui/material';
const BasicSelect = (props) => {
  return (
    <FormControl sx={{ paddingBottom: "15px" }} fullWidth variant="outlined">
      <Box display={"flex"} alignItems={"center"} mb={1}>
        {props.icon}
        <label>{props.label}</label>
      </Box>
      <Select
        value={props.value || props.value}
        onChange={(e) => props.onChangeText(e.target.value)}
        variant={"outlined"}
      >
        {props?.dropdownListArr?.map((option) => (
          <MenuItem key={option.key || option.name} value={option.value || option.name}>
            {option.value || option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BasicSelect;
